import React from 'react'
import PropTypes from 'prop-types'
import * as request from 'services/request'
import ManagedUsersList from './managed-users-list'
import AddManagedUserModal from './add-managed-user-modal'
import R from 'ramda'
import notify from 'utils/notification'

const filterOutSelectedUser = (selectedUser) => (users) => {
  return users.filter(user => user.id !== selectedUser.id)
}

const filterOutManagedUsers = (managedUsers) => (users) => {
  const managedUserIds = managedUsers.map(user => user.id)
  return users.filter(user => !managedUserIds.includes(user.id))
}

class ManageUsersForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      managedUsers: [],
      showAddManagedUserModal: false
    }

    this.getManagedUsers = this.getManagedUsers.bind(this)
    this.addManagedUser = this.addManagedUser.bind(this)
    this.removeManagedUser = this.removeManagedUser.bind(this)
    this.toggleAddManagedUserModal = this.toggleAddManagedUserModal.bind(this)
  }

  componentDidMount () {
    this.getManagedUsers()
  }

  toggleAddManagedUserModal () {
    this.setState({
      showAddManagedUserModal: !this.state.showAddManagedUserModal
    })
  }

  async getManagedUsers () {
    try {
      const response = await request.authorized(`/users/${this.props.selectedUser.id}/managed`)

      if (response.status !== 200) throw new Error(await response.text())

      const managedUsers = await response.json()

      this.setState({managedUsers: filterOutSelectedUser(this.props.selectedUser)(managedUsers)})
    } catch (error) {
      console.error('Error getting managed users', error)
      notify.error({
        message: 'Error getting managed users'
      })
    }
  }

  async addManagedUser (userId) {
    try {
      const response = await request.authorized(`/users/${this.props.selectedUser.id}/managed?userId=${userId}`, {
        method: 'POST'
      })

      if (response.status !== 200) throw new Error(await response.text())

      this.getManagedUsers()
      this.toggleAddManagedUserModal()
      notify.success({
        message: 'Succesfully added managed user'
      })
    } catch (error) {
      console.error('Error adding managed user', error)
      notify.error({
        message: 'Error adding managed user'
      })
    }
  }

  async removeManagedUser (userId) {
    try {
      const response = await request.authorized(`/users/${this.props.selectedUser.id}/managed?userId=${userId}`, {
        method: 'DELETE'
      })

      if (response.status !== 200) throw new Error(await response.text())

      this.getManagedUsers()
      notify.success({
        message: 'Succesfully removed managed user'
      })
    } catch (error) {
      console.error('Error removing managed user', error)
      notify.error({
        message: 'Error removing managed user'
      })
    }
  }

  get unmanagedUsers () {
    const filteredUsers = R.pipe(
      filterOutSelectedUser(this.props.selectedUser),
      filterOutManagedUsers(this.state.managedUsers)
    )(this.props.users)
    return filteredUsers
  }

  render () {
    return (
      <div>
        <div className='portlet light' style={{ border: '1px solid #bbb' }}>
          <h4 style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}>
            Managed Users
            <button className='btn green' onClick={this.toggleAddManagedUserModal}>
              <i className='fa fa-users' /> Add user
            </button>
          </h4>
          <div className='row'>
            <AddManagedUserModal
              name={this.props.selectedUser.screenName}
              onAddUser={this.addManagedUser}
              onClose={this.toggleAddManagedUserModal}
              show={this.state.showAddManagedUserModal}
              users={this.unmanagedUsers}
            />
          </div>

          <ManagedUsersList
            users={this.state.managedUsers}
            count={this.state.managedUsers.length}
            emptyMessage={`${this.props.selectedUser.screenName} is not currently managing any users.`}
            removeManagedUser={this.removeManagedUser}
          />
        </div>
      </div>
    )
  }
}

ManageUsersForm.propTypes = {
  selectedUser: PropTypes.object.isRequired,
  users: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default ManageUsersForm



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/user-permissions/manage-users-form.js